import React from "react"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers"
import { ICON_CONSTANTS } from "../../../../constants/ImageConstants.js"

export const ResetSvgIcon = () => {
  return (
    <span className="svg-icon svg-icon-md svg-icon-primary">
      <SVG src={toAbsoluteUrl(ICON_CONSTANTS.RESET_ONLY)} />
    </span>
  )
}
